export default {
    fillToPageNews(state,data){
        data=Object.assign({},state.data,data)
        state.data=data
    }
}
